import json from './sprite.js';

export default {
    handle: 'es_TOM-Toybox',
    label: 'es_TOM-Toybox',
    json,
};
